import leftPad from 'left-pad'

export default {
  numberToTime (number) {
    const base = new Date(1970, 1, 1, 0, 0, 0).valueOf()
    const date = new Date(number * 1000 + base)
    return date
  },
  numberToTimeString (number) {
    const date = this.numberToTime(number)
    const h = leftPad(date.getHours(), 2, '0')
    const m = leftPad(date.getMinutes(), 2, '0')
    const s = leftPad(date.getSeconds(), 2, '0')
    return `${h}:${m}:${s}`
  },
  timeToNumber (time) {
    const base = new Date(1970, 1, 1, 0, 0, 0).valueOf()
    return (time.valueOf() - base.valueOf()) / 1000
  },
  HmToNumber (time) {
    var str = time
    const arr = str.split(':')
    const seconds = arr[0] * 3600 + arr[1] * 60
    // console.log(seconds)
    return seconds
  }
}
